import { FC } from "react";

const LoadingFrame1: FC<{ size?: string }> = ({ size = "99" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 99 99"
      fill="none"
    >
      <path
        d="M85.5 49.5C85.5 69.4 69.4 85.5 49.5 85.5C29.6 85.5 13.5 69.4 13.5 49.5C13.5 29.6 29.6 13.5 49.5 13.5C69.4 13.5 85.5 29.6 85.5 49.5ZM20.6 49.5C20.6 65.5 33.5 78.4 49.5 78.4C65.5 78.4 78.4 65.5 78.4 49.5C78.4 33.5 65.5 20.6 49.5 20.6C33.5 20.6 20.6 33.5 20.6 49.5Z"
        fill="url(#paint0_angular_1209_27386)"
      />
      <defs>
        <radialGradient id="paint0_angular_1209_27386" cx="0" cy="0" r="1">
          <stop stopColor="rgb(139, 96, 48)" />
          <stop offset="1" stopColor="rgb(244, 235, 224)" stopOpacity="0.21" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default LoadingFrame1;
